import { useState } from 'react';
import { LivePriceSymbolsKeyEnum } from 'global/Datafeed/UseLivePrice/liveprice.store.types';
import { OrderbookSymbolsKeyEnum } from 'global/Datafeed/UseOrderbook/orderbook.store.types';
import { useRawOrderbook } from 'global/Datafeed/UseOrderbook/useRawOrderbook';
import useBestBidOffer from 'global/Datafeed/useBestBidOffer';
import { useOrderbookIEPIEV } from 'global/Datafeed/useOrderbookIEPIEV';
import { useRawLivePrice } from 'global/Datafeed/UseLivePrice/useRawLivePrice';

const useFastOrderDatafeed = (symbol: string) => {
  const [orderbook, setOrderbook] = useState<OrderBookResponse>();
  const [livePrice, setLivePrice] = useState<LivePriceResponse>();
  const [iepiev, setIepIev] = useState<DatafeedIEPIEVResponse>();
  const [bestBidOffer, setBestBidOffer] = useState<BestBidOfferResponse>();

  useRawOrderbook(
    [symbol],
    OrderbookSymbolsKeyEnum.FAST_ORDER,
    'fast_order',
    setOrderbook,
  );
  useRawLivePrice(
    [symbol],
    LivePriceSymbolsKeyEnum.FAST_ORDER,
    'fast_order',
    setLivePrice,
  );
  useOrderbookIEPIEV([symbol], 'fast_order', setIepIev);
  useBestBidOffer([symbol], 'fast_order', setBestBidOffer);

  return { orderbook, livePrice, iepiev, bestBidOffer };
};

export default useFastOrderDatafeed;
